import { render, staticRenderFns } from "./PublicityComponent.vue?vue&type=template&id=3dedd578"
import script from "./PublicityComponent.vue?vue&type=script&lang=js"
export * from "./PublicityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports